module.exports = __webpack_public_path__ + "static/compliance-a1ad539e46ccd8af71b17399b7bfb752.svg";